// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"a687dc34","299":"4b1dea2d","734":"4b1dea2d","928":"4b1dea2d"}[chunkId] + ".chunk.css";
};